import React from 'react';
import { useMatchedRoute } from '../../../common/router/hooks';
import { ROUTE_COMPONENT_MAP } from './route-component-map';

const Router: React.FC = () => {
  const matchedRouteParams = useMatchedRoute();
  const Component =
    ROUTE_COMPONENT_MAP[
      (matchedRouteParams.route as keyof typeof ROUTE_COMPONENT_MAP) ??
        raise('No matched route found')
    ];
  return <Component {...matchedRouteParams} />;
};

const raise = (message: string): never => {
  throw new Error(message);
};

export default Router;
